import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Bank } from '../../models/admin-models/bank.model';
import { Filter } from '../../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class BankService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/banks/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/banks/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createBank(bank: Bank) {
        return this.httpClient.post('api/banks/create', bank.data).toPromise();
    }

    editBank(bank: Bank) {
        return this.httpClient.post('api/banks/edit', bank.data).toPromise();
    }

    deleteBank(ids: Array<Number>) {
        return this.httpClient.post('api/banks/delete', ids).toPromise();
    }

}